import Crudcook from "../assets/images/Crudcook_logo.jfif"
import Gemini from "../assets/images/Gemini_logo.jfif"
import DIC from "../assets/images/DIC_logo.jfif"
import Star from "../assets/images/Star_logo.jfif"
import TPC from "../assets/images/TPC_logo.jfif"
import GDSC from "../assets/images/Gdsc.jpg"
const experience = [
    {
      date: "12/06/2022 - 12/07/2022",
      image: Crudcook,
      event: "Full Stack Development Intern",
      detail: "Worked on Frontend side with React, Material UI, Ant Design Frontend Libraries on Home pages of these websites.",
      skills: " Crudcook Inc.",
      // link: "https://www.linkedin.com/company/crudcook/"
      link: "https://drive.google.com/file/d/14MV1S930o8aNuNHQUvCwZ6Jv78G2-U-2/view?usp=sharing"
    },
    {
      date: "10/04/2022 - Present",
      image: Gemini,
      event:
        "Campus Ambassador",
      detail: "Increase awareness of company's program in College and University.",
      skills: "Gemini Solutions",
      link: "https://www.linkedin.com/company/gemini-solutions-india/mycompany/"
    },
    {
        date: "26/07/2021 - 26/07/2022",
        image: DIC,
        event:
          "Research Intern(AI Team)",
        detail: "Worked on Denoising, data augmentation, data analysis-Exploratory, Image Classification, Image Processing, Brain Tumor Detection, etc.",
        skills: " Design and Innovation Centre, MDart, UIET",
        // link: "https://www.linkedin.com/company/dic-panjab-university/mycompany/"
        link: "https://drive.google.com/file/d/1oOghgNtTaNYk_PVlczhYeVNOhKsoUPsz/view?usp=sharing"
      },
      {
        date: "20/12/2020 - 20/12/2022",
        image: Star,
        event:
          "Website Development(Sub-Head)",
        detail: "Worked on the enhancement of the website by adding new webpages, responsiveness, plugins, etc.",
        skills: "Student Team for Alumni Relations",
        link: "https://www.linkedin.com/company/alumni-affairs-cell-uiet/mycompany/"
      },
      {
        date: "20/03/2021 - Present",
        image: TPC,
        event:
          "Co - Cheif Placement Coordinator",
        detail: "Conducted drives of various companies such as American Express, Samsung, Optum, KPMG ,ZS Associates, Deloitte, etc. ",
        skills: " Training and Placement Cell",
        link: "https://www.linkedin.com/company/training-placement-cell-uiet-panjab-university-chandigarh/mycompany/"
      },
      {
        date: "20/08/2022 - Present",
        image: GDSC,
        event:
          " AI/ML Lead",
        detail: "Helping students bridge the gap between theory and practice. Assisting students in learning and implementing Machine Learning and Deep Learning. ",
        skills: " Google Developer Student Club",
        link: "https://www.linkedin.com/company/google-developer-student-club-uiet-panjab-university/"
      }
  ];
  
  export default experience;
  